<script lang="ts">
  import Link from '$components/ui/link.svelte';
  import { t } from '$lib/i18n';
  import Translation from '$lib/i18n/translation.svelte';
  import { buildPath } from '$lib/utils/paths';
</script>

<p class="mt-3 text-sm text-primary/80">
  <Translation key="auth.legal-text" let:match>
    {#if match === 'terms'}
      <Link
        target="_blank"
        href={$buildPath({
          path: $t('auth.legal.terms.link')
        })}
      >
        {$t('auth.legal.terms')}
      </Link>
    {:else if match === 'privacy'}
      <Link
        target="_blank"
        href={$buildPath({
          path: $t('auth.legal.privacy.link')
        })}
      >
        {$t('auth.legal.privacy')}
      </Link>
    {/if}
  </Translation>
</p>
